<template>
	<div class="content-button">
		<div :class="`button-text ${control && itemNumberPost > 0 ? 'button-active': 'button-unactive'} `" @click="onApprove()">
			<v-icon v-if="$vuetify.breakpoint.lgAndUp && !postLoading" small color="white" class="mr-1">mdi-check</v-icon>
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && postLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#FFFFFF`" indeterminate></v-progress-circular>			
			<span>
				Post
				<span v-if="$vuetify.breakpoint.mdAndUp && itemNumberPost > 0">({{ itemNumberPost }})</span>
			</span>
		</div>
		<div :class="`button-text button-default-text ml-2 ${control && itemNumberMoreInfo > 0 ? 'button-default-able':'button-default-unable'}`" @click="onMoreInfo()">
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && rejectLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			<span>
				Reject
				<span v-if="itemNumberMoreInfo > 0">({{ itemNumberMoreInfo }})</span>
			</span>
		</div>
		<div :class="`button-text ${control && itemNumberForward > 0 ? 'button-default-able':'button-default-unable'} ml-2`" @click="onForward()">
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && forwardLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			<span>
				Forward
				<span v-if="itemNumberForward > 0">({{ itemNumberForward }})</span>
			</span>
		</div>
		<div v-if="$vuetify.breakpoint.mdAndUp" :class="`button-text ${control ? 'button-default-able':'button-default-unable'} ml-2`" @click="onPrint()">
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && printLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			Print
			<span v-if="$vuetify.breakpoint.lgAndUp && itemNumberPrint > 0">({{ itemNumberPrint }})</span>
		</div>
		<div v-if="$vuetify.breakpoint.mdAndUp" :class="`button-text ${control && itemNumberDelete > 0 ? 'button-default-able':'button-default-unable'} ml-2`" @click="onDelete()">
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && deleteLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			Delete
			<span v-if="$vuetify.breakpoint.lgAndUp && itemNumberDelete > 0">({{ itemNumberDelete }})</span>
		</div>
		<div v-if="$vuetify.breakpoint.mdAndUp" :class="`button-text ${control && itemNumberRecover > 0 ? 'button-default-able':'button-default-unable'} ml-2`" @click="onRecover()">
			<v-progress-circular v-if="$vuetify.breakpoint.lgAndUp && recoverLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			Recover
			<span v-if="$vuetify.breakpoint.lgAndUp && itemNumberRecover > 0">({{ itemNumberRecover }})</span>
		</div>
	</div>
</template>
<script>

export default {
	name: 'FinanceButtonMulti',
	props: {
		control: {
			type: Boolean,
			default: false
		},
		itemNumberPost: {
			type: Number,
			default: 0
		},
		itemNumberMoreInfo: {
			type: Number,
			default: 0
		},
		itemNumberForward: {
			type: Number,
			default: 0
		},
		itemNumberPrint: {
			type: Number,
			default: 0
		},
		itemNumberDelete: {
			type: Number,
			default: 0
		},
		itemNumberRecover: {
			type: Number,
			default: 0
		},
		postLoading: {
			type: Boolean,
			default: false
		},
		rejectLoading: {
			type: Boolean,
			default: false
		},
		forwardLoading: {
			type: Boolean,
			default: false
		},
		deleteLoading: {
			type: Boolean,
			default: false
		},
		printLoading: {
			type: Boolean,
			default: false
		},
		recoverLoading: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onApprove() {
			if (this.control && this.itemNumberPost > 0) {
				this.$emit('post-gl');
			}
		},
		onMoreInfo() {
			if (this.control && this.itemNumberMoreInfo > 0) {
				this.$emit('more-info');
			}
		},
		onForward() {
			if (this.control && this.itemNumberForward > 0) {
				this.$emit('forward');
			}
		},
		onPrint() {
			if (this.control) {
				this.$emit('print')
			}
		},
		onDelete() {
			if (this.control && this.itemNumberDelete > 0) {
				this.$emit('delete')
			}
		},
		onRecover() {
			if (this.control && this.itemNumberRecover > 0) {
				this.$emit('recover')
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.content-button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.button-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  padding: 0 12px;
  border-radius: 4px;
}
.button-active {
  background: #00AAFD;
  color: #FFFFFF;
  &:hover {
    cursor: pointer;
  }
}
.button-unactive {
  background: rgba(25, 42, 62, 0.15);
  color: #FFFFFF;
}
.button-default-able {
  border: 1px solid #00AAFD;
  color: #00AAFD;
  &:hover {
    cursor: pointer;
  }
}
.button-default-unable {
  border: 1px solid rgba(25, 42, 62, 0.3);
  color: rgba(25, 42, 62, 0.3);
}
</style>